import { Box } from '@mui/material';
import Image from 'next/image';

export const ProductImage = ({ source, alt }: { source: string; alt?: string }) => {
  return (
    <Box
      sx={{
        minWidth: '137px',
        maxWidth: { xs: '144px', sm: '190px', md: '232px' },
        height: { xs: '90px', sm: '100px' },
        position: 'relative',
      }}
    >
      <Image src={source} alt={alt ?? ''} fill style={{ objectFit: 'contain' }} />
    </Box>
  );
};
